"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_native_paper_1 = require("react-native-paper");
const react_native_gesture_handler_1 = require("react-native-gesture-handler");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const eventSlice_1 = require("./eventSlice");
const eventConstants_1 = require("./eventConstants");
const styles_1 = __importDefault(require("../../styles/styles"));
const colors_1 = __importDefault(require("../../styles/colors"));
const scheduleSlice_1 = require("../../features/schedules/scheduleSlice");
const button_1 = __importDefault(require("../button/button"));
const stopWatch_1 = __importDefault(require("../stopWatch/stopWatch"));
const defaultProps = {
    buttonProps: null,
};
const EventQueueBox = ({ buttonProps }) => {
    const dispatch = useAppDispatch_1.default();
    const { token, eventSocket, voipUserId, queueMemberMetrics } = useAppSelector_1.default((state) => ({
        token: state.auth.token,
        voipUserId: state.auth.user.voip_user_id,
        eventSocket: state.event.socket,
        queueMemberMetrics: state.event.queueMemberMetrics,
    }));
    const currentTimeEpoch = Math.floor(new Date().getTime() / 1000);
    const lastCallEpoch = parseInt(queueMemberMetrics.LastCall, 10); // convert epoch string to base 10
    const callLatency = currentTimeEpoch - lastCallEpoch;
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(eventSlice_1.newSocket({ token }));
        // Lets close the connection when an agent leaves this screen.
        return () => {
            dispatch(eventSlice_1.resetSocketState());
        };
    }, []));
    react_1.useEffect(() => {
        if (!eventSocket)
            return;
        // Define messageHandler to handle incoming messages
        const messageHandler = (event) => {
            const payload = JSON.parse(event.data);
            if (payload.Event === eventConstants_1.QUEUE_MEMBER_STATUS) {
                const officerVoipUserId = payload.MemberName.replace('PJSIP/', '');
                // Check if officerVoipUserId matches the current officer voipUserId
                if (officerVoipUserId === voipUserId) {
                    dispatch(eventSlice_1.setQueueMemberMetrics(payload));
                }
            }
            else if (payload.type === eventConstants_1.SCHEDULE) {
                // If this is a schedule, display it to the agent.
                dispatch(scheduleSlice_1.setScheduleData({ schedule: payload.schedule, data: payload.external_data }));
            }
        };
        const openHandler = () => {
            dispatch(eventSlice_1.setQueueMemberMetrics({ ...queueMemberMetrics, Status: eventConstants_1.CONNECTION_OPEN }));
        };
        eventSocket.addEventListener('message', messageHandler);
        eventSocket.addEventListener('open', openHandler);
    }, [eventSocket]);
    return (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles] },
        react_1.default.createElement(react_native_gesture_handler_1.ScrollView, { horizontal: true, showsHorizontalScrollIndicator: true, contentContainerStyle: [
                styles_1.default.flexDirectionRow,
                styles_1.default.alignSpaceBetween,
                { minWidth: '100%' },
            ] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginLeftTen] },
                react_1.default.createElement(react_native_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPlug, size: 30, color: eventConstants_1.STATUS_COLORS.get(queueMemberMetrics.Status) }),
                react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.marginFive] }, eventConstants_1.STATUS_LABELS.get(queueMemberMetrics.Status))),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginLeftTen] },
                react_1.default.createElement(react_native_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTasks, size: 30, color: colors_1.default.BLUE_2 }),
                react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.marginFive] }, queueMemberMetrics.Queue || 'No queue')),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginLeftTen] },
                react_1.default.createElement(react_native_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faHeadphones, size: 30, color: colors_1.default.BLUE_2 }),
                react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.marginFive] }, queueMemberMetrics.CallsTaken)),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginLeftTen] },
                react_1.default.createElement(react_native_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faStopwatch, size: 30, color: colors_1.default.BLUE_2 }),
                react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.marginFive] }, lastCallEpoch ? react_1.default.createElement(stopWatch_1.default, { timeInSeconds: callLatency }) : 0)),
            buttonProps && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginLeftTen] },
                react_1.default.createElement(button_1.default, { onPress: buttonProps.onPress, text: buttonProps.text, eventName: buttonProps.eventName }))))));
};
EventQueueBox.defaultProps = defaultProps;
exports.default = EventQueueBox;
